<script>
	import {mapGetters} from 'vuex'

	export default {
		name: 'Results',
		data() {
			return {
				componentName: 'Results',
			}
		},
		components: {},
		props: [],
		computed: {
			...mapGetters([]),
		},
		methods: {},
		mounted() {
			// Called after the instance has just been mounted where el is replaced by the newly created vm.el. If the root instance is mounted to an in-document element, vm.el will also be in-document when mounted is called.
			this.$nextTick(() => {
				// console.log('<Results> is ready and attached to the dom', this)
			})
		},
	}
</script>
<!-- ******************************************************************* -->
<template>
	<div class="Results">
		LETS DO IT
		<v-list class="ma-2">
			<v-list-tile>
				Test
			</v-list-tile>
			<v-list-tile>
				Test
			</v-list-tile>
			<v-list-tile>
				Test
			</v-list-tile>
		</v-list>

		Things to try
		<v-list>
			<v-list-tile>
				Test
			</v-list-tile>
			<v-list-tile>
				Test
			</v-list-tile>
			<v-list-tile>
				Test
			</v-list-tile>
		</v-list>

		For the hell of it
		<v-list>
			<v-list-tile>
				Test
			</v-list-tile>
			<v-list-tile>
				Test
			</v-list-tile>
			<v-list-tile>
				Test
			</v-list-tile>
		</v-list>
	</div>
</template>
<!-- ******************************************************************* -->
<style scoped>
	.Results {
	}
</style>
